import { resolveApiUrl } from "../../utils/url/urlResolver";
import type { MediaItemDetails } from "../types/mediaLibraryTypes";

export async function fetchMediaItemDetails(id: string): Promise<MediaItemDetails[]> {
  const params = new URLSearchParams();
  params.set("id", id);

  const url = `/media-library/preview?${params}`;
  const apiUrl = resolveApiUrl(url);

  const response = await fetch(apiUrl, {
    method: "GET",
    credentials: "same-origin",
    mode: "cors",
    referrer: "no-referrer",
    headers: {
      dataType: "json",
      "content-type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Error status: ${response.status}`);
  }

  const data = await response.json();
  return data;
}
